import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import { Function as SpaceFunction } from '../../../../../../../../space/function'
import * as _function from '../function'

export const RESOURCE = {
  payload: {
    modelId: _function.MODEL_ID,
    values: {
      [PartialId.Standard.create('active_periods')]: '{[,]}',
      [PartialId.Standard.create('code')]:
        SpaceFunction.Standard.Code.Unassignable,
      [PartialId.Standard.create('descr')]:
        'Space that cannot be assigned to a functional usage.',
      [PartialId.Standard.create('id')]: SpaceFunction.Standard.Id.Unassignable,
      [PartialId.Standard.create('is_exclusive')]: true,
      [PartialId.Standard.create('is_sponsored')]: false,
      [PartialId.Standard.create('name')]: 'Unassignable',
    },
  },
  type: core.quiver.Resource.Type.DmsRecord,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsRecord>
